// tslint:disable:no-bitwise
import { getResourceIconInfo } from "../features/generic/icon/getResourceIconInfo";
var UtilGrantRewards = /** @class */ (function () {
    function UtilGrantRewards() {
        this.isPackageShopReward = function (grantReward) {
            var paymentOfferId = grantReward.paymentOfferId;
            return paymentOfferId != undefined && paymentOfferId.length > 0;
        };
        this.isRewardResources = function (grantReward) {
            var paymentOfferId = grantReward.paymentOfferId, resourceRewards = grantReward.resourceRewards;
            return (resourceRewards.length !== 0 &&
                (paymentOfferId == undefined || paymentOfferId.length === 0));
        };
        this.isRewardBuildings = function (grantReward) {
            var buildingRewards = grantReward.buildingRewards;
            return buildingRewards.length !== 0;
        };
        this.isRewardProfilePictures = function (grantReward) {
            var profilePictureRewards = grantReward.profilePictureRewards;
            return profilePictureRewards.length !== 0;
        };
        this.isRewardSnippets = function (grantReward) {
            var convertedSnippetsFromProfilePicture = grantReward.convertedSnippetsFromProfilePicture;
            return convertedSnippetsFromProfilePicture.length !== 0;
        };
        this.getSnippetsRewards = function (grantReward) {
            var convertedSnippetsFromProfilePicture = grantReward.convertedSnippetsFromProfilePicture;
            return convertedSnippetsFromProfilePicture.map(function (resource) { return getResourceIconInfo(resource); });
        };
        this.getResourcesRewards = function (grantReward) {
            var resourceRewards = grantReward.resourceRewards, convertedSnippetsFromProfilePicture = grantReward.convertedSnippetsFromProfilePicture;
            var iconsInfo = [];
            resourceRewards.forEach(function (resource) { return iconsInfo.push(getResourceIconInfo(resource)); });
            convertedSnippetsFromProfilePicture.forEach(function (snippet) {
                return iconsInfo.push(getResourceIconInfo(snippet));
            });
            return iconsInfo;
        };
        this.getUniqueAnimationId = function (grantReward) {
            var packageId = grantReward.packageId, packageAmount = grantReward.packageAmount, sourceId = grantReward.sourceId;
            return parseInt("" + packageAmount + packageId + sourceId, 10);
        };
    }
    return UtilGrantRewards;
}());
export var utilGrantRewards = new UtilGrantRewards();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilGrantRewards.ts
// module id = 554
// module chunks = 3